import React from "react";
import "./TMHFormStyles.css";

function TMHFormWrapper({children, classOption="tmhform-wrapper", ...restProps}) {
  return (
    <div className={classOption} {...restProps}>
      {children}
    </div>
  );
}

export default TMHFormWrapper;
